/**
 * See Array.isArray.
 * @memberof youbora.Util
 */
module.exports = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/youboralib/src/mixins/isarray.js
// module id = 27
// module chunks = 0